import './NavButton.css';

export function NavButton(props) {
    return (
      <a href={props.address} className='link-layout'>
        <button className='nav-button' onClick={props.onClick}>{props.title}</button>
      </a>
    )
  }